import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom, forkJoin, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { PopUpMensajeComponent, PopUpMensajeData } from '../../../contratante-page/components/pop-up-mensaje/pop-up-mensaje.component';
import { CalculoPendientePrograma, EstadoInicialPrograma, EstadoLiquidacionPrograma, ResumenCotizacionProgramaComponent } from '../resumen-cotizacion-programa/resumen-cotizacion-programa.component';
import { ConsultarCotizacionService } from '../../../../../../services/cotizador-cotizacion/consultar-cotizacion.service';
import {
  CampaniaDetalleItem,
  ConsultarCampaniaDetalleHttpResponse
} from '../../../../../../models/cotizador-cotizacion/consultar-campania-detalle/response/consultar-campania-detalle-response.model';
import {
  BeneficiarioCotizacion,
  BeneficiarioProgramaCampaniaCotizacion,
  BeneficiarioProgramaCotizacion,
  BeneficiarioProgramaTarifaCotizacion,
  LiquidacionIndividualItem
} from '../../../../../../models/cotizador-cotizacion/consultar-cotizacion-guardada/response/consultar-cotizacion-guardada-response.model';
import { ModalEnviarCotizacionComponent, ModalEnviarCotizacionData } from '../modal-enviar-cotizacion/modal-enviar-cotizacion.component';
import { environment } from '../../../../../../../environments/environment';
import { URL_MAP } from '../../../../../../shared/urlMap';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { CotizacionEdicionData, NetworkingMyQuotation } from '../../../../../../services/mis-cotizaciones/miscotizaciones.service';
import { AuthService } from '../../../../../../services/security/auth.service';
import { ConsultarAsesorByIDService } from '../../../../../../services/cotizador-contratante/consultar-asesor-by-id.service';
import { ConsultarAsesorByIDRequest } from '../../../../../../models/cotizador-contratante/consultar-asesor/request/consultar-asesor-byID-request.model';
import { ProcesandoCotizacionComponent } from '../procesando-cotizacion/procesando-cotizacion.component';
import {
  NetworkingQuotation
} from '../../../../../../services/servicioCotizador/cotizador.service';
import { CrearCotizacionContratanteService } from '../../../../../../services/cotizador-contratante/crear-cotizacion-contratante.service';
interface ResumenProgramaItem {
  id: string;
  programaId: string;
  lineaNegocio: string;
  programaTitulo: string;
  rows: ResumenCotizacionRow[];
}

interface ResumenCotizacionRow {
  idBeneficiario?: number | null;
  idBenPrograma?: number | null;
  nombre: string;
  precioBaseMensual: number;
  precioBaseMensualAnexos: number;
  aplicaAnexos: boolean;
  descuentosCampana: number;
  pagoProporcionalIngresoAnticipado: number;
  descuentoProntoPago: number;
  valorTotalPeriodoProntoPago: number;
  precioBaseTarifaAsociado: number;
  modalLineaNegocio: string;
  modalPrograma: string;
  modalTarifaMensual: number;
  modalDescripcionTarifa: string;
  modalTarifaCodigo?: string;
  modalCampaniaCodigo: string;
  modalCampaniaNombre: string;
  modalCampaniaInicioVigencia: string;
  modalCampaniaFinVigencia: string;
  idCotizacionCampania: number | null;
  beneficiarioEdad?: number;
  beneficiarioGenero?: string;
  beneficiarioParentesco?: string;
  cuotaInscripcionValor?: number;
}

interface LiquidacionDraftRowStorage {
  idCotizacion: number;
  idBeneficiario: number;
  idBenPrograma: number;
  precioBaseMensual: number;
  precioBaseMensualAnexos: number;
  descuentoCampania: number;
  idCotizacionCampania: number | null;
  aplicaProporcionalidad: 'S' | 'N';
  fechaIngreso: string | null;
  diaCorte: number | null;
  diasProporcionalidad: number;
  valorProporcional: number;
  aplicaCuotaInscripcion: 'S' | 'N';
  valorCuotaInscripcion: number;
  valorCuotaInscripcionContrato: number;
  mesesProntoPago: number;
  pctDescuentoProntoPago: number;
  valorTotalProntoPago: number;
  aplicaTarifaAsociado: 'S' | 'N';
  precioBaseTarifaAsociado: number;
  fechaCreacion: string;
}

interface LiquidacionDraftStorage {
  idCotizacion: number;
  guardadoEn: string;
  liquidaciones: LiquidacionDraftRowStorage[];
}

interface GuardarLiquidacionBackendResponse {
  status: boolean;
  codeStatus: string;
  message: string;
  data?: {
    operacion: string;
    idCotizacion: number;
    idsLiquidaciones: number[];
  } | null;
  errorMessage?: string | null;
}

interface ComparativoBackendItemRequest {
  lineaNegocio: string;
  programa1: string;
  programa2: string;
  precioBaseMensualTotalP1: string;
  precioBaseMensualAnexosP1: string;
  descuentoCampaniaTotalP1: string;
  pagoProporcionalTotalP1: string;
  porcentajeDescuentoProntoP1: string;
  valorTotalProntoP1: string;
  precioBaseMensualTotalP2: string;
  precioBaseMensualAnexosP2: string;
  descuentoCampaniaTotalP2: string;
  pagoProporcionalTotalP2: string;
  porcentajeDescuentoProntoP2: string;
  valorTotalProntoP2: string;
}

interface GuardarComparativoBackendResponse {
  status: boolean;
  codeStatus: string;
  message: string;
  data?: {
    operacion: string;
    idCotizacion: number;
    idsComparativos: number[];
  } | null;
  errorMessage?: string | null;
}

interface CotizacionContratanteActual {
  idCotizacion: number | string;
  tipoDocumento?: string;
  numeroDocumento?: string;
}

interface ComparativoSeleccionConsultaItem {
  lineaNegocio: string;
  programa1: string;
  programa2: string;
}

@Component({
  selector: 'app-cotizador-cotizacion',
  templateUrl: './cotizador-cotizacion.component.html',
  styleUrls: ['./cotizador-cotizacion.component.css'],
})
export class CotizadorCotizacionComponent implements OnInit {
  resumenProgramas: ResumenProgramaItem[] = [];
  cedulaAsesor = '';
  idAsesor: number | null = null;
  NombreCompleto = '';
  NumeroDocumento = '';
  correoAsesor = '';
  celularAsesor = '';
  ciudadAsesor = '';

  camposCompletosMock = false;
  guardadoExitoso = false;
  cambiosSinGuardar = false;
  guardandoEnCurso = false;
  cargandoUltimaPantalla = false;
  bloqueoPostGuardadoExitoso = false;
  procesandoCotizacion = false; // variable para indicar que se está procesando la cotización y deshabilitar el botón de descarga
  estadoInicialPorPrograma = new Map<string, EstadoInicialPrograma>();
  private inicializandoEstado = true;
  private estadoPorPrograma = new Map<string, EstadoLiquidacionPrograma>();
  private readonly KEY_DATOS_CONTRATANTE = 'datosRQ002_Contratante';
  private readonly KEY_COTIZACION_ACTUAL = 'cotizacion_contratante_actual';
  private readonly KEY_COTIZACION_CREADA =
    'cotizacion_creada_desde_contratante';
  private readonly KEY_COTIZACION_PRECARGADA = 'cotizacion_precargada';
  private readonly KEY_COTIZACION_CARGADA = 'cotizacion_cargada';
  private readonly KEY_PROGRAMAS_CONTRATANTE = 'programas_contratante';
  private readonly KEY_RQ005_LIQUIDACIONES_GUARDADAS =
    'rq005_liquidaciones_guardadas';
  private readonly KEY_RQ005_CONSECUTIVO_LOCAL = 'rq005_consecutivo_local';
  private readonly KEY_COMPARAR_STORAGE = 'rq006_comparar_programas_por_linea';
  private readonly guardarLiquidacionUrl = `${environment.HOST}${URL_MAP.API.GUARDAR_COTIZACION_LIQUIDACION}`;
  private readonly actualizarLiquidacionUrl = `${environment.HOST}${URL_MAP.API.ACTUALIZAR_COTIZACION_LIQUIDACION}`;
  private readonly guardarComparativoUrl = `${environment.HOST}${URL_MAP.API.GUARDAR_COTIZACION_COMPARATIVO}`;
  private readonly actualizarComparativoUrl = `${environment.HOST}${URL_MAP.API.ACTUALIZAR_COTIZACION_COMPARATIVO}`;
  private idEstadoCotizacionActual: number | null = null;
  private _idCotizacionOverride: number | null = null;
  /**
   * true cuando el usuario está viendo la versión más reciente de la cotización.
   * En ese caso, después de aplicar el snapshot (que puede estar desactualizado),
   * se hace un refresh HTTP para mostrar el estado actual del servidor.
   */
  private _isLatestVersion = true; // default true: al init siempre es la más reciente
  /** Debounce timer: colapsa múltiples triggers síncronos de cargarResumenDesdeCotizacionGuardada() en uno solo. */
  private _cargarResumenTimer: ReturnType<typeof setTimeout> | null = null;
  private _cargaResumenEnCurso = false;
  private _cargaRevision = 0;
  private readonly operacionesCargaPendientes = new Set<string>();
  private cargaInicialTerminada = false;
  private esperandoInicializacionProgramas = false;
  private tieneComparativoBackend = false;
  private comparativoInicialPorLinea = new Map<string, string[]>();
  private readonly ESTADO_GUARDADA = 2;
  private readonly ESTADO_ENVIADA = 3;

  @Input() deshabilitadoPorVersionHistorica = false;
  @Output() bloqueoNavegacionChange = new EventEmitter<boolean>();
  @Output() versionCreadaEvent = new EventEmitter<number>();
  @Output() cargaInicialChange = new EventEmitter<boolean>();
  @Input() cotizacionModificadaExternamente = false;

  get bloqueoInteraccionCotizacion(): boolean {
    return this.guardandoEnCurso || this.bloqueoPostGuardadoExitoso;
  }

  get cargaRevision(): number {
    return this._cargaRevision;
  }

  @Input() set isLatestVersion(v: boolean) {
    this._isLatestVersion = v;
  }

  @Input() set idCotizacion(id: number | null) {
    if (id && id > 0 && id !== this._idCotizacionOverride) {
      this._idCotizacionOverride = id;
      this.cargarResumenDesdeCotizacionGuardada();
    }
  }

  /**
   * En modo edición individual, el padre pasa cotizacionEdicionData cada vez que cambia
   * (init + cada cambio de versión). Si el snapshot tiene datos de programas, los usa
   * directamente para evitar llamar GET /edit (que siempre retorna estado actual).
   * Fallback: si el snapshot no tiene programas, llama igual al HTTP.
   */
  @Input() set cotizacionData(data: CotizacionEdicionData | null) {
    if (!data?.idCotizacion || !data?.beneficiarios?.length) return;
    const beneficiarios = data.beneficiarios as unknown as BeneficiarioCotizacion[];
    const hasProgramas = beneficiarios.some(
      (b) => Array.isArray(b.programas) && b.programas.length > 0,
    );
    if (!hasProgramas) {
      if (this.deshabilitadoPorVersionHistorica || !this._isLatestVersion) {
        this.aplicarBeneficiariosSnapshot([], this.idEstadoCotizacionActual, data.idCotizacion);
        this.construirEstadoInicialDesdeBackend(data.liquidacionesIndividual);
        return;
      }

      // El snapshot no tiene datos de tarifas: forzar recarga HTTP con el id correcto
      this._idCotizacionOverride = data.idCotizacion;
      this.cargarResumenDesdeCotizacionGuardada();
      return;
    }
    // Para versiones históricas NO pisar idEstadoCotizacionActual con el estado del snapshot
    // (el snapshot guarda idEstado=3/ENVIADA — el estado al momento de la foto, no el estado actual)
    const idEstadoAplicar = this._isLatestVersion
      ? (data.idEstado ?? null)
      : this.idEstadoCotizacionActual;
    this.aplicarBeneficiariosSnapshot(
      beneficiarios,
      idEstadoAplicar,
      data.idCotizacion,
    );
    // Restaurar parámetros de cotización guardados (proporcionalidad, cuota, pronto pago, tarifa asociado)
    this.construirEstadoInicialDesdeBackend(data.liquidacionesIndividual);
    if (this.deshabilitadoPorVersionHistorica || !this._isLatestVersion) {
      const comparativosSnapshot = Array.isArray((data as any)?.comparativos)
        ? (data as any).comparativos
        : [];
      this.tieneComparativoBackend = comparativosSnapshot.length > 0;
      ResumenCotizacionProgramaComponent.aplicarCompararDesdeBackend(
        this.mapearCompararStorageDesdeComparativos(comparativosSnapshot),
      );
    }
    // Para la versión más reciente el snapshot puede estar desactualizado
    // (ej: se asignaron programas a un beneficiario después de crear el snapshot).
    // Siempre lanzamos un refresh HTTP para que el servidor corrija el estado final.
    if (this._isLatestVersion && !this.deshabilitadoPorVersionHistorica && this._idCotizacionOverride) {
      this.cargarResumenDesdeCotizacionGuardada();
    }
  }

  constructor(
    private dialog: MatDialog,
    private consultarCotizacionService: ConsultarCotizacionService,
    private http: HttpClient,
    private router: Router,
    private networkingMyQuotation: NetworkingMyQuotation,
    private authService: AuthService,
    private consultarAsesorByIDService: ConsultarAsesorByIDService,
    private networkingMisCot: NetworkingMyQuotation,
    private networkingQuotation: NetworkingQuotation,
    private crearCotizacionContratanteService: CrearCotizacionContratanteService,
  ) {
    ResumenCotizacionProgramaComponent.resetCompararMock();
  }

  async ngOnInit(): Promise<void> {
    this.cargarResumenDesdeCotizacionGuardada();
    await this.consultarIDxAsesor();
  }

  trackByProgramaId(_: number, item: ResumenProgramaItem): string {
    return item.id;
  }

  /**
   * Recarga el resumen desde GET /cotizacion/{id}/edit.
   * Lo invoca el padre al entrar a la pestaña COTIZACIÓN (p. ej. tras agregar beneficiarios).
   */
  recargarResumenDesdeEdit(): void {
    if (this.deshabilitadoPorVersionHistorica || !this._isLatestVersion) {
      return;
    }

    const id =
      this._idCotizacionOverride && this._idCotizacionOverride > 0
        ? this._idCotizacionOverride
        : this.getIdCotizacionEnCurso();
    if (!id) {
      this.camposCompletosMock = false;
      return;
    }
    this._idCotizacionOverride = id;
    this.cargarResumenDesdeCotizacionGuardada();
  }

  private obtenerDatosContratanteDesdeStorage(): {
    idCotizacion: number;
    nombreContratante: string;
    emailDestinatario: string;
    numeroDocumento: string;
  } {
    let nombreContratante = '';
    let emailDestinatario = '';
    let numeroDocumento = '';

    try {
      const raw = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
      if (raw) {
        const parsed = JSON.parse(raw);

        nombreContratante = [
          parsed?.primerNombre,
          parsed?.segundoNombre,
          parsed?.primerApellido,
          parsed?.segundoApellido,
        ]
          .map((v: any) => (v ?? '').toString().trim())
          .filter(Boolean)
          .join(' ')
          .trim();

        emailDestinatario = (parsed?.emailPrincipal ?? '').toString().trim();
        numeroDocumento = (parsed?.numeroDocumento ?? '').toString().trim();
      }
    } catch (error) {
      console.error('Error leyendo datosRQ002_Contratante:', error);
    }

    return {
      idCotizacion: this.getIdCotizacionEnCurso() ?? 0,
      nombreContratante,
      emailDestinatario,
      numeroDocumento,
    };
  }

  guardar(): void {
    if (!this.camposCompletosMock) {
      this.validarYMostrarMock('GUARDAR');
      return;
    }
    if (this.cargandoUltimaPantalla) {
      return;
    }
    if (
      this.guardandoEnCurso ||
      this.bloqueoPostGuardadoExitoso ||
      this.deshabilitadoPorVersionHistorica
    ) {
      return;
    }
    // Si hay exactamente 1 programa marcado para comparar: solo popup, sin guardar ni bloquear.
    if (!this.validarComparacionMinima()) {
      return;
    }
    this.guardandoEnCurso = true;
    this.guardarLiquidacion();
  }

  // enviarCotizacion(): void {
  //   if (!this.guardadoExitoso) {
  //     this.dialog.open(PopUpMensajeComponent, {
  //       width: '500px',
  //       maxWidth: '90vw',
  //       disableClose: true,
  //       data: {
  //         titulo: 'Advertencia',
  //         texto: 'Debe guardar la información antes de enviar la cotización.',
  //         tipoIcono: 'warning',
  //         textoBoton: 'ACEPTAR'
  //       } as PopUpMensajeData
  //     });
  //     return;
  //   }
  //   if (!this.validarComparacionMinima()) {
  //     return;
  //   }

  //   const idCotizacion = this.getIdCotizacionEnCurso();
  //   const numeroCotizacion = idCotizacion ? idCotizacion.toString() : '';
  //   const nombreCliente = this.obtenerNombreCliente();

  //   this.dialog.open(ModalEnviarCotizacionComponent, {
  //     width: '96vw',
  //     maxWidth: '1100px',
  //     disableClose: true,
  //     data: {
  //       titulo: 'Enviar cotización',
  //       pdfUrl: this.getPdfPreviewUrl(),
  //       idCotizacion: idCotizacion || 0,
  //       numeroCotizacion: numeroCotizacion,
  //       nombreCliente: nombreCliente
  //     }
  //   }).afterClosed().subscribe(() => { });
  // }

  private obtenerNombreCliente(): string {
    try {
      const raw = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
      if (!raw) return '';

      const parsed = JSON.parse(raw);
      return [
        parsed?.primerNombre,
        parsed?.segundoNombre,
        parsed?.primerApellido,
        parsed?.segundoApellido,
      ]
        .map((v: any) => (v ?? '').toString().trim())
        .filter(Boolean)
        .join(' ')
        .trim();
    } catch {
      return '';
    }
  }

  private obtenerEmailDestinatario(): string {
    try {
      const raw = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
      if (!raw) return '';

      const parsed = JSON.parse(raw);
      return (parsed?.emailPrincipal ?? '').toString().trim();
    } catch {
      return '';
    }
  }

  async consultarIDxAsesor(): Promise<string> {
    try {
      const authInfo = await this.authService.getAuthInfo();
      const documentUser = authInfo.document;
      console.log('Información de autenticación obtenida:', authInfo);

      this.cedulaAsesor = documentUser.split('.')[1].trim();
      console.log('Documento asesor:', this.cedulaAsesor);

      this.idAsesor = await this.networkingMisCot.obtenerIdAsesorPorDocumento(
        this.cedulaAsesor,
      );
      console.log('Id asesor CotizadorCotizacion -->', this.idAsesor);

      if (this.idAsesor == null) {
        console.warn('No se obtuvo idAsesor');
        return this.cedulaAsesor;
      }

      const request: ConsultarAsesorByIDRequest = {
        nombreClave: 'getSpCotConsultarAsesorPorID',
        jsonParametros: JSON.stringify({
          prm_id_asesor: String(this.idAsesor),
        }),
      };

      const response = await firstValueFrom(
        this.consultarAsesorByIDService.consultarAsesorByID(request),
      );

      console.log('consultarAsesorByID CotizadorCotizacion:', response);

      if (
        response?.status &&
        Array.isArray(response.data) &&
        response.data.length > 0
      ) {
        const asesor = response.data[0];

        this.NombreCompleto = (asesor?.NombreCompleto ?? '').toString().trim();
        this.NumeroDocumento = (asesor?.NumeroDocumento ?? '')
          .toString()
          .trim();
        this.correoAsesor = (asesor?.email ?? '').toString().trim();
        this.celularAsesor = (asesor?.telefono ?? '').toString().trim();
        this.ciudadAsesor = this.capitalizeFirstLetter(
          (asesor?.ciudad ?? '').toString().trim(),
        );
      } else {
        console.warn(
          'No se encontró información del asesor para el id CotizadorCotizacion:',
          this.idAsesor,
        );
      }

      return this.cedulaAsesor;
    } catch (error) {
      console.error('Error al obtener la información del asesor CotizadorCotizacion:', error);
      return this.cedulaAsesor;
    }
  }

  private obtenerCodigosProgramasParaBrochures(): string[] {
    const codigos = new Set<string>();

    (this.resumenProgramas ?? []).forEach((programa) => {
      const codigoDesdeFila = (
        programa?.rows?.[0]?.modalPrograma ?? ''
      )
        .toString()
        .trim()
        .toUpperCase();

      const partesProgramaId = (programa?.programaId ?? '')
        .toString()
        .split('|');

      const codigoDesdeId = (
        partesProgramaId.length > 1
          ? partesProgramaId[1]
          : partesProgramaId[0]
      )
        .toString()
        .trim()
        .toUpperCase();

      const codigo = codigoDesdeFila || codigoDesdeId;

      if (codigo) {
        codigos.add(codigo);
      }
    });

    const resultado = Array.from(codigos);

    console.log(
      'Códigos de programas individuales para brochures:',
      resultado
    );

    return resultado;
  }

  descargarPDFDesdeDatos(): void {

    // evitar ejecutar metdo si ya se esta procesando la cotizacion
    if (this.procesandoCotizacion){
      return;
    }

    const { idCotizacion, nombreContratante, emailDestinatario } =
      this.obtenerDatosContratanteDesdeStorage();

    if (!idCotizacion || idCotizacion <= 0) {
      this.dialog.open(PopUpMensajeComponent, {
        width: '500px',
        maxWidth: '90vw',
        disableClose: true,
        data: {
          titulo: 'Advertencia',
          texto: 'No se encontro el id de la cotizacion para generar el PDF.',
          tipoIcono: 'warning',
          textoBoton: 'ACEPTAR',
        } as PopUpMensajeData,
      });
      return;
    }

    if (!this.NombreCompleto || !this.celularAsesor || !this.correoAsesor) {
      this.dialog.open(PopUpMensajeComponent, {
        width: '500px',
        maxWidth: '90vw',
        disableClose: true,
        data: {
          titulo: 'Advertencia',
          texto:
            'No se encontro la informacion completa del asesor para generar el PDF.',
          tipoIcono: 'warning',
          textoBoton: 'ACEPTAR',
        } as PopUpMensajeData,
      });
      return;
    }

    const pComparativo = this.obtenerPComparativoParaJasper();
    const pCuotaInscripcion =
        this.obtenerPCuotaInscripcionParaJasper();
    const pPagoProporcionalAnticipado =
        this.obtenerPPagoProporcionalParaJasper();
    const pPrecioBaseAnexos =
        this.obtenerPPrecioBaseAnexosParaJasper();
    const pTarifaAsociado =
        this.obtenerPTarifaAsociadoParaJasper();
    const pdfUrl = 
      this.crearPdfInlineUrl(
        idCotizacion,
        pComparativo,
        pCuotaInscripcion,
        pPagoProporcionalAnticipado,
        pPrecioBaseAnexos,
        pTarifaAsociado
      );

    console.log('Parámetros enviados a Jasper:', {
        P_COMPARATIVO: pComparativo,
        P_CUOTA_INSCRIPCION: pCuotaInscripcion,
        P_PAGO_PROPORCIONAL_ANTICIPADO:
            pPagoProporcionalAnticipado,
        P_PRECIO_BASE_ANEXOS: pPrecioBaseAnexos,
        P_TARIFA_ASOCIADO: pTarifaAsociado,
    });

    this.procesandoCotizacion = true; // bloqueo clicks al boton

    // mostrar la ventana de carga
    const loadingRef = this.dialog.open(ProcesandoCotizacionComponent, {
      width: '360px',
      maxWidth: '90vw',
      disableClose: true,
      closeOnNavigation: false,
      autoFocus: false,
      restoreFocus: false,
      panelClass: 'procesando-cotizacion-panel',

    });

    // evitar cerrar y bloquear la ventana de carga hasta que se complete la descarga del PDF
    let procesoFinalizado = false;

    const finalizarProcesamiento = () => {
      if (procesoFinalizado) {
        return;
      }
      
      procesoFinalizado = true;
      loadingRef.close();
      this.procesandoCotizacion = false; // desbloqueo clicks al boton
    }

    this.networkingMyQuotation
      .descargarPdfCotizacionIndividual(
        this.NombreCompleto.trim(),
        this.celularAsesor.trim(),
        this.correoAsesor.trim(),
        idCotizacion,
        pComparativo,
        pCuotaInscripcion,
        pPagoProporcionalAnticipado,
        pPrecioBaseAnexos,
        pTarifaAsociado,
        this.ciudadAsesor
      )
      .subscribe({
        next: (pdfBlob: Blob) => {
          pdfBlob
            .arrayBuffer()
            .then((buffer) => {
              const header = String.fromCharCode(
                ...new Uint8Array(buffer.slice(0, 5)),
              );

              if (!header.startsWith('%PDF')) {
                console.error('Header invalido. No es un PDF valido.');
                console.error(
                  'Primeros 100 bytes del buffer:',
                  new Uint8Array(buffer.slice(0, 100)),
                );

                // cerrar la ventana de carga y desbloquear el boton
                finalizarProcesamiento();

                this.dialog.open(PopUpMensajeComponent, {
                  width: '500px',
                  maxWidth: '90vw',
                  disableClose: true,
                  data: {
                    titulo: 'Error',
                    texto:
                      'No se pudo generar el PDF. El contenido recibido no es un PDF valido.',
                    tipoIcono: 'error',
                    textoBoton: 'ACEPTAR',
                  } as PopUpMensajeData,
                });
                return;
              }

              const reader = new FileReader();
              reader.onload = () => {
                const dataUrl = reader.result as string;
                const pdfBase64 = dataUrl.split(',')[1] ?? '';
                const blobUrl = URL.createObjectURL(pdfBlob);

                const programasSeleccionados =
                  this.obtenerCodigosProgramasParaBrochures();

                console.log(
                  'Programas enviados al servicio de brochures:',
                  programasSeleccionados
                );

                this.networkingQuotation
                  .obtenerBrochuresPorProgramas(programasSeleccionados)
                  .subscribe({
                    next: (brochuresProgramas) => {
                      console.log(
                        'Brochures recibidos por el frontend:',
                        brochuresProgramas.map((brochure) => ({
                          programa: brochure.programa,
                          nombreArchivo: brochure.nombreArchivo,
                          mimeType: brochure.mimeType,
                          base64Length: brochure.pdfBase64?.length ?? 0,
                          inicioBase64:
                            brochure.pdfBase64?.substring(0, 10) ?? ''
                        }))
                      );

                      finalizarProcesamiento();

                      const dialogRef = this.dialog.open(
                        ModalEnviarCotizacionComponent,
                        {
                          width: '96vw',
                          maxWidth: '1100px',
                          disableClose: true,
                          data: {
                            titulo: 'Cotización Individual',
                            pdfUrl,
                            pdfDownloadUrl: blobUrl,
                            idCotizacion,
                            numeroCotizacion: idCotizacion.toString(),
                            nombreCliente: nombreContratante,
                            esColectivo: false,
                            emailDestinatario,
                            pdfBase64,
                            nombreContratante,
                            brochuresProgramas
                          } as ModalEnviarCotizacionData
                        }
                      );

                      dialogRef.afterClosed().subscribe(() => {
                        URL.revokeObjectURL(blobUrl);
                      });
                    },
                    error: (error) => {
                      console.error(
                        'Error consultando brochures individuales:',
                        error
                      );

                      finalizarProcesamiento();

                      // La cotización puede abrirse aunque falle la consulta de brochures.
                      const dialogRef = this.dialog.open(
                        ModalEnviarCotizacionComponent,
                        {
                          width: '96vw',
                          maxWidth: '1100px',
                          disableClose: true,
                          data: {
                            titulo: 'Cotización Individual',
                            pdfUrl: blobUrl,
                            pdfDownloadUrl: blobUrl,
                            idCotizacion,
                            numeroCotizacion: idCotizacion.toString(),
                            nombreCliente: nombreContratante,
                            esColectivo: false,
                            emailDestinatario,
                            pdfBase64,
                            nombreContratante,
                            brochuresProgramas: []
                          } as ModalEnviarCotizacionData
                        }
                      );

                      dialogRef.afterClosed().subscribe(() => {
                        URL.revokeObjectURL(blobUrl);
                      });
                    }
                  });
              };

              reader.onerror = () => {
                console.error(
                  'Error leyendo el pdf',
                  reader.error
                );
              
                finalizarProcesamiento();

                this.dialog.open(PopUpMensajeComponent, {
                  width: '500px',
                  maxWidth: '90vw',
                  disableClose: true,
                  data: {
                    titulo: 'Error',
                    texto: 'No fue posible procesar el PDF.',
                    tipoIcono: 'error',
                    textoBoton: 'ACEPTAR',
                  } as PopUpMensajeData,
                });              
              };
              
              reader.onabort = () => {
                console.error('La lectura del PDF fue cancelada.');

                finalizarProcesamiento();

                this.dialog.open(PopUpMensajeComponent, {
                  width: '500px',
                  maxWidth: '90vw',
                  disableClose: true,
                  data: {
                    titulo: 'Error',
                    texto: 'La lectura del archivo PDF fue cancelada.',
                    tipoIcono: 'error',
                    textoBoton: 'ACEPTAR',
                  } as PopUpMensajeData,
                });
              };
              reader.readAsDataURL(pdfBlob);
            })
            .catch((err) => {
              console.error('Error procesando PDF individual:', err);
              finalizarProcesamiento();
              this.dialog.open(PopUpMensajeComponent, {
                width: '500px',
                maxWidth: '90vw',
                disableClose: true,
                data: {
                  titulo: 'Error',
                  texto:
                    err?.message || 'Error procesando el PDF de la cotizacion.',
                  tipoIcono: 'error',
                  textoBoton: 'ACEPTAR',
                } as PopUpMensajeData,
              });
            });
        },
        error: (err) => {
          console.error(
            'Error completo al generar el PDF de la cotizacion individual:',
            err,
          );

          finalizarProcesamiento();

          this.dialog.open(PopUpMensajeComponent, {
            width: '500px',
            maxWidth: '90vw',
            disableClose: true,
            data: {
              titulo: 'Error',
              texto: err?.message || 'Error desconocido al descargar el PDF.',
              tipoIcono: 'error',
              textoBoton: 'ACEPTAR',
            } as PopUpMensajeData,
          });
        },
      });
  }

  enviarCotizacion(): void {
    if (!this.guardadoExitoso) {
      this.dialog.open(PopUpMensajeComponent, {
        width: '500px',
        maxWidth: '90vw',
        disableClose: true,
        data: {
          titulo: 'Advertencia',
          texto: 'Debe guardar la información antes de enviar la cotización.',
          tipoIcono: 'warning',
          textoBoton: 'ACEPTAR',
        } as PopUpMensajeData,
      });
      return;
    }
    if (!this.validarComparacionMinima()) {
      return;
    }

    const { idCotizacion, nombreContratante, emailDestinatario } =
      this.obtenerDatosContratanteDesdeStorage();

    this.dialog
      .open(ModalEnviarCotizacionComponent, {
        width: '96vw',
        maxWidth: '1100px',
        disableClose: true,
        data: {
          titulo: 'Cotización Individual',
          pdfUrl: this.crearPdfInlineUrl(
            idCotizacion || 0,
            this.obtenerPComparativoParaJasper(),
            this.obtenerPCuotaInscripcionParaJasper(),
            this.obtenerPPagoProporcionalParaJasper(),
            this.obtenerPPrecioBaseAnexosParaJasper(),
            this.obtenerPTarifaAsociadoParaJasper()
          ),
          idCotizacion: idCotizacion || 0,
          numeroCotizacion: (idCotizacion || 0).toString(),
          nombreCliente: nombreContratante,
          esColectivo: false,
          emailDestinatario: emailDestinatario,
          nombreContratante: nombreContratante,
        } as ModalEnviarCotizacionData,
      })
      .afterClosed()
      .subscribe(() => {});
  }

  // private obtenerNombreCliente(): string {
  //   try {
  //     const raw = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
  //     if (!raw) return '';
  //     const parsed = JSON.parse(raw);
  //     return (parsed?.nombreContratante ?? '').toString().trim() ||
  //            (parsed?.nombre ?? '').toString().trim() || '';
  //   } catch {
  //     return '';
  //   }
  // }

  private validarYMostrarMock(accion: string): void {
    const linea = this.resumenProgramas[0]?.lineaNegocio ?? 'MI';
    const selected = ResumenCotizacionProgramaComponent.getCompararCount(linea);

    // Requisito visual: si intentan proceder con solo 1 programa comparado.
    if (selected === 1) {
      this.dialog.open(PopUpMensajeComponent, {
        width: '500px',
        maxWidth: '90vw',
        disableClose: true,
        data: {
          titulo: 'Advertencia',
          texto:
            'La opción de comparación solo aplica para 2 programas de la misma línea de negocio.',
          tipoIcono: 'warning',
          textoBoton: 'ACEPTAR',
        } as PopUpMensajeData,
      });
      return;
    }

    // Mock de confirmación visual (por ahora solo estética).
    this.dialog.open(PopUpMensajeComponent, {
      width: '500px',
      maxWidth: '90vw',
      disableClose: true,
      data: {
        titulo: 'Mock',
        texto: `Acción: ${accion}`,
        tipoIcono: 'info',
        textoBoton: 'ACEPTAR',
      } as PopUpMensajeData,
    });
  }

  private validarComparacionMinima(): boolean {
    const seleccionPorLinea = this.obtenerSeleccionCompararPorLinea();
    const { haySeleccionIncompleta } =
      this.construirPayloadComparativos(seleccionPorLinea);

    if (haySeleccionIncompleta) {
      this.mostrarAdvertenciaComparacionMinima();
      return false;
    }

    return true;
  }

  private crearPdfInlineUrl(
    idCotizacion: number,
    pComparativo: string,
    pCuotaInscripcion: string,
    pPagoProporcionalAnticipado: string,
    pPrecioBaseAnexos: string,
    pTarifaAsociado: string
  ): string {
    if (!idCotizacion) {
      return 'about:blank';
    }

    const params = new HttpParams()
      .set(
        'idCotizacion',
        idCotizacion.toString()
      )
      .set(
        'nombreAsesor',
        this.NombreCompleto.trim()
      )
      .set(
        'telefonoAsesor',
        this.celularAsesor.trim()
      )
      .set(
        'correoAsesor',
        this.correoAsesor.trim()
      )
      .set(
        'comparativo',
        pComparativo
      )
      .set(
        'cuotaInscripcion',
        pCuotaInscripcion
      )
      .set(
        'pagoProporcionalAnticipado',
        pPagoProporcionalAnticipado
      )
      .set(
        'precioBaseAnexos',
        pPrecioBaseAnexos
      )
      .set(
        'tarifaAsociado',
        pTarifaAsociado
      )
      .set(
        'ciudadAsesor',
        this.ciudadAsesor ?? ''
      );

    const nombreArchivo =
      `cotización_${idCotizacion}.pdf`;

    return (
      `${environment.HOST}` +
      `${URL_MAP.API.PDF_COTIZACION_INDIVIDUAL}/` +
      `${nombreArchivo}?${params.toString()}`
    );
  }

  private cargarResumenDesdeCotizacionGuardada(): void {
    if (this._cargarResumenTimer !== null) {
      clearTimeout(this._cargarResumenTimer);
    }
    this._cargarResumenTimer = setTimeout(() => {
      this._cargarResumenTimer = null;
      this._ejecutarCargaResumen();
    }, 0);
  }

  private _ejecutarCargaResumen(): void {
    if (this.deshabilitadoPorVersionHistorica || !this._isLatestVersion) {
      return;
    }
    if (this._cargaResumenEnCurso) {
      return;
    }

    const idCotizacion = this.getIdCotizacionEnCurso();
    if (!idCotizacion) {
      this.camposCompletosMock = false;
      this.cargaInicialTerminada = true;
      this.esperandoInicializacionProgramas = false;
      this.cargaInicialChange.emit(false);
      return;
    }

    this._cargaResumenEnCurso = true;
    const revision = this.iniciarCargaInicial();
    this.iniciarOperacionCarga('resumen', revision);
    this.consultarCotizacionService
      .consultarCotizacionGuardada(idCotizacion)
      .pipe(
        finalize(() => {
          this._cargaResumenEnCurso = false;
          this.finalizarOperacionCarga('resumen', revision);
        }),
      )
      .subscribe({
        next: (response) => {
          const beneficiarios = response?.data?.beneficiarios ?? [];
          this.idEstadoCotizacionActual =
            Number(response?.data?.idEstado ?? 0) || null;
          this.aplicarBeneficiariosSnapshot(
            beneficiarios,
            this.idEstadoCotizacionActual,
            idCotizacion,
            revision,
          );
          this.construirEstadoInicialDesdeBackend(response?.data?.liquidacionesIndividual);
        },
        error: (error) => {
          console.error('Error al consultar cotización guardada:', error);
          this.camposCompletosMock = false;
        },
      });
  }

  /**
   * Aplica la lista de beneficiarios al resumen (RQ005) sin hacer HTTP.
   * Usado tanto desde la respuesta HTTP como desde el snapshot de versión.
   */
  private aplicarBeneficiariosSnapshot(
    beneficiarios: BeneficiarioCotizacion[],
    idEstado: number | null,
    idCotizacion: number,
    revision?: number,
  ): void {
    const cargaRevision = revision ?? this.iniciarCargaInicial();
    this.idEstadoCotizacionActual = idEstado;
    this.resumenProgramas = this.mapearResumenProgramas(beneficiarios);
    // Esperar un ciclo de Angular para que cada resumen hijo registre sus operaciones.
    this.esperandoInicializacionProgramas = true;

    // Purgar entradas obsoletas: programas eliminados dejan IDs stale en el map.
    // Si no se limpian, construirLiquidacionesDesdeEstado incluye rows con
    // idCotizacionCampania que ya no existe en DB → FK_LIQ_CAMP violation.
    const activeProgramaIds = new Set(this.resumenProgramas.map((p) => p.programaId));
    for (const key of Array.from(this.estadoPorPrograma.keys())) {
      if (!activeProgramaIds.has(key)) {
        this.estadoPorPrograma.delete(key);
      }
    }
    for (const key of Array.from(this.operacionesCargaPendientes)) {
      if (key.startsWith('programa:')) {
        const programaId = key.split(':')[1] ?? '';
        if (!activeProgramaIds.has(programaId)) {
          this.operacionesCargaPendientes.delete(key);
        }
      }
    }

    this.camposCompletosMock = this.resumenProgramas.length > 0;
    if (this.deshabilitadoPorVersionHistorica || !this._isLatestVersion) {
      this.guardadoExitoso = false;
      this.tieneComparativoBackend = false;
      this.guardarEstadoInicialComparativo({});
      ResumenCotizacionProgramaComponent.aplicarCompararDesdeBackend({});
    } else if (this.bloqueoPostGuardadoExitoso) {
      this.guardadoExitoso = true;
    } else {
      this.hidratarGuardadoLocalPorCotizacion(idCotizacion);
      this.hidratarCompararDesdeBackend(idCotizacion, cargaRevision);
    }
    this.inicializandoEstado = true;
    setTimeout(() => {
      this.inicializandoEstado = false;
      this.recalcularBotonesPorEstado();
    }, 0);
    this.enrichDescuentosCampanaMes1Resumen(cargaRevision);
    setTimeout(() => {
      if (cargaRevision !== this._cargaRevision) return;
      this.esperandoInicializacionProgramas = false;
      this.actualizarEstadoCarga(cargaRevision);
    }, 0);
  }

  /**
   * RQ005: agrupar por combinación lineaNegocio + programa.
   * Precio base mensual / anexos: una sola tarifa aplicable (fueSeleccionada), no sumar todas.
   */
  private mapearResumenProgramas(
    beneficiarios: BeneficiarioCotizacion[],
  ): ResumenProgramaItem[] {
    const grupos = new Map<
      string,
      {
        programaId: string;
        lineaNegocio: string;
        programaTitulo: string;
        rowsByBeneficiario: Map<string, ResumenCotizacionRow>;
      }
    >();

    (beneficiarios ?? []).forEach((beneficiario) => {
      const nombreBeneficiario = this.getNombreBeneficiario(beneficiario);
      const keyBeneficiario = this.getKeyBeneficiario(beneficiario);

      (beneficiario.programas ?? []).forEach((programa) => {
        const linea = this.normalizarLinea(
          (programa as any)?.lineaNegocio
          ?? (programa as any)?.linea_negocio
          ?? (programa as any)?.lineaNegocioNombre
          ?? (programa as any)?.linea
        );
        const codigoPrograma = (
          programa?.programa
          ?? (programa as any)?.planCodi
          ?? (programa as any)?.codigo
          ?? (programa as any)?.id
          ?? ''
        ).toString().trim();
        if (!linea || !codigoPrograma) return;

        const keyGrupo = `${linea}|${codigoPrograma}`;
        const nombreProg = (programa?.nombrePrograma ?? codigoPrograma)
          .toString()
          .trim();
        let grupo = grupos.get(keyGrupo);
        if (!grupo) {
          grupo = {
            programaId: keyGrupo,
            lineaNegocio: linea,
            programaTitulo: `Programa ${nombreProg} - ${linea}`,
            rowsByBeneficiario: new Map<string, ResumenCotizacionRow>(),
          };
          grupos.set(keyGrupo, grupo);
        }

        const row: ResumenCotizacionRow = {
          idBeneficiario: Number(beneficiario?.idBeneficiario ?? 0) || null,
          idBenPrograma: Number(programa?.idBenPrograma ?? 0) || null,
          nombre: nombreBeneficiario,
          precioBaseMensual: 0,
          precioBaseMensualAnexos: 0,
          aplicaAnexos: false,
          descuentosCampana: 0,
          pagoProporcionalIngresoAnticipado: 0,
          descuentoProntoPago: 0,
          valorTotalPeriodoProntoPago: 0,
          precioBaseTarifaAsociado: 0,
          modalLineaNegocio: linea,
          modalPrograma: codigoPrograma,
          modalTarifaMensual: 0,
          modalDescripcionTarifa: '',
          modalTarifaCodigo: '',
          modalCampaniaCodigo: '',
          modalCampaniaNombre: '',
          modalCampaniaInicioVigencia: '',
          modalCampaniaFinVigencia: '',
          idCotizacionCampania: null,
          beneficiarioEdad: Number(beneficiario?.edad ?? 0) || 0,
          beneficiarioGenero: (beneficiario?.genero ?? '').toString().trim(),
          beneficiarioParentesco: (beneficiario?.parentescoId ?? 'T').toString().trim(),
        };
        this.aplicarValoresLiquidacionRow(row, programa);
        grupo.rowsByBeneficiario.set(keyBeneficiario, row);
      });
    });

    return Array.from(grupos.entries())
      .map(([key, grupo]) => ({
        id: key,
        programaId: grupo.programaId,
        lineaNegocio: grupo.lineaNegocio,
        programaTitulo: grupo.programaTitulo,
        rows: Array.from(grupo.rowsByBeneficiario.values()),
      }))
      .sort((a, b) => {
        const orden = (linea: string): number =>
          linea === 'MI' ? 1 : linea === 'SAO' ? 2 : linea === 'CEM' ? 3 : 99;
        const diffLinea = orden(a.lineaNegocio) - orden(b.lineaNegocio);
        if (diffLinea !== 0) return diffLinea;
        return (
          a.rows[0]?.modalPrograma?.localeCompare(
            b.rows[0]?.modalPrograma ?? '',
          ) ?? 0
        );
      });
  }

  /**
   * Suma `valorMensualIva` de tarifas con `esAnexo` acorde al tipo (base vs anexo).
   * No usa `fueSeleccionada`: en cotización guardada base y anexo vienen como filas distintas.
   */
  private sumarValorMensualIvaPorEsAnexo(
    tarifas: BeneficiarioProgramaTarifaCotizacion[] | undefined,
    esAnexo: boolean,
  ): number {
    return (tarifas ?? [])
      .filter((t) => (t.esAnexo === true) === esAnexo)
      .reduce((acc, t) => {
        const v = Number(t.valorMensualIva ?? 0);
        return acc + (Number.isFinite(v) && v > 0 ? v : 0);
      }, 0);
  }

  private primeraTarifaPorEsAnexo(
    tarifas: BeneficiarioProgramaTarifaCotizacion[] | undefined,
    esAnexo: boolean,
  ): BeneficiarioProgramaTarifaCotizacion | undefined {
    const lista = (tarifas ?? []).filter((t) => (t.esAnexo === true) === esAnexo);
    return lista.find((t) => t.fueSeleccionada === true) ?? lista[0];
  }

  /** Campaña para modal/descuentos: preferir fueSeleccionada. */
  private campaniaLiquidacion(
    programa: BeneficiarioProgramaCotizacion,
  ): BeneficiarioProgramaCampaniaCotizacion | undefined {
    const lista = programa?.campanias ?? [];
    const sel = lista.find((c) => c.fueSeleccionada === true);
    if (sel) return sel;
    return lista[0];
  }

  private aplicarValoresLiquidacionRow(
    row: ResumenCotizacionRow,
    programa: BeneficiarioProgramaCotizacion,
  ): void {
    const linea = this.normalizarLinea(programa?.lineaNegocio);
    const codigoPrograma = (programa?.programa ?? '').toString().trim();
    row.modalLineaNegocio = linea;
    row.modalPrograma = codigoPrograma;

    const listaTarifas = programa?.tarifas;
    row.precioBaseMensual = this.sumarValorMensualIvaPorEsAnexo(
      listaTarifas,
      false,
    );

    row.precioBaseMensualAnexos = this.sumarValorMensualIvaPorEsAnexo(
      listaTarifas,
      true,
    );

    row.aplicaAnexos = (listaTarifas ?? []).some(
      tarifa => tarifa.esAnexo === true
    );

    const tarifaBase = this.primeraTarifaPorEsAnexo(listaTarifas, false);
    const tarifaAnexo = this.primeraTarifaPorEsAnexo(listaTarifas, true);
    row.modalDescripcionTarifa = (
      tarifaBase?.nombreTarifa ??
      tarifaAnexo?.nombreTarifa ??
      ''
    )
      .toString()
      .trim();
    row.modalTarifaCodigo = (tarifaBase?.tari ?? tarifaAnexo?.tari ?? '')
      .toString()
      .trim()
      .toUpperCase();
    row.modalTarifaMensual = row.precioBaseMensual;

    const campania = this.campaniaLiquidacion(programa);

    if (campania) {
      row.modalCampaniaCodigo = (campania.codCampComercial ?? '')
        .toString()
        .trim();
      row.modalCampaniaNombre = (campania.nombreCampania ?? '')
        .toString()
        .trim();
      row.modalCampaniaInicioVigencia = (campania.inicioVigencia ?? '')
        .toString()
        .trim();
      row.modalCampaniaFinVigencia = (campania.finVigencia ?? '')
        .toString()
        .trim();
      const idCc = Number(campania.idCotizacionCampania ?? 0);
      row.idCotizacionCampania =
        Number.isFinite(idCc) && idCc > 0 ? idCc : null;
    } else {
      row.modalCampaniaInicioVigencia = '';
      row.modalCampaniaFinVigencia = '';
      row.idCotizacionCampania = null;
    }
  }

  /**
   * RQ005: columna "Descuentos por Campaña" = impacto en mes 1 (valor aproximado en $ según % mes 1 del maestro).
   */
  private enrichDescuentosCampanaMes1Resumen(revision: number): void {
    const ids = new Set<number>();
    this.resumenProgramas.forEach((p) => {
      p.rows.forEach((row) => {
        const id = row.idCotizacionCampania;
        if (id != null && id > 0) {
          ids.add(id);
        }
      });
    });
    const uniqueIds = [...ids];
    if (!uniqueIds.length) {
      return;
    }

    uniqueIds.forEach((id) => this.iniciarOperacionCarga(`campania:${id}`, revision));

    forkJoin(
      uniqueIds.map((id) =>
        this.consultarCotizacionService.consultarCampaniaDetalle(id).pipe(
          catchError(() =>
            of({
              status: false,
              codeStatus: '404',
              message: '',
              data: null,
              errorMessage: null,
            } as ConsultarCampaniaDetalleHttpResponse),
          ),
        ),
      ),
    )
      .pipe(
        finalize(() => {
          uniqueIds.forEach((id) => this.finalizarOperacionCarga(`campania:${id}`, revision));
        }),
      )
      .subscribe((responses) => {
      if (revision !== this._cargaRevision) {
        return;
      }
      const detallePorId = new Map<number, CampaniaDetalleItem[]>();
      uniqueIds.forEach((id, idx) => {
        const r = responses[idx];
        if (r?.status && r.data?.detalles?.length) {
          detallePorId.set(id, r.data.detalles);
        }
      });

      this.resumenProgramas = this.resumenProgramas.map((prog) => ({
        ...prog,
        rows: prog.rows.map((row) => {
          const idCc = row.idCotizacionCampania;
          if (idCc == null || idCc <= 0) {
            return { ...row, descuentosCampana: 0 };
          }
          const detalles = detallePorId.get(idCc) ?? [];
          const mes1 = detalles.find((d) => d.numeroCuota === 1);
          const pct = Number(mes1?.porcentajeDescuento ?? 0);
          const tarifa = Number(row.modalTarifaMensual ?? 0);
          const desc =
            Number.isFinite(pct) && pct > 0 && tarifa > 0
              ? Math.round(tarifa * (pct / 100))
              : 0;
          return { ...row, descuentosCampana: desc };
        }),
      }));
    });
  }

  private getNombreBeneficiario(beneficiario: BeneficiarioCotizacion): string {
    return [
      beneficiario?.primerNombre,
      beneficiario?.segundoNombre,
      beneficiario?.primerApellido,
      beneficiario?.segundoApellido,
    ]
      .map((v) => (v ?? '').toString().trim())
      .filter(Boolean)
      .join(' ')
      .trim()
      .toUpperCase();
  }

  private capitalizeFirstLetter(value: string): string {
    const trimmed = (value ?? '').toString().trim();
    if (!trimmed) {
      return '';
    }
    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
  }

  private getKeyBeneficiario(beneficiario: BeneficiarioCotizacion): string {
    const id = Number(beneficiario?.idBeneficiario ?? 0);
    if (Number.isFinite(id) && id > 0) return `ID:${id}`;
    const tipoDoc = (beneficiario?.tipoDocumento ?? '').toString().trim();
    const numDoc = (beneficiario?.numDocumento ?? '').toString().trim();
    return `${tipoDoc}|${numDoc}`;
  }

  private normalizarLinea(linea: unknown): 'MI' | 'SAO' | 'CEM' | '' {
    const value = (linea ?? '').toString().trim().toUpperCase();
    if (value === 'MI' || value === 'SMP' || value.includes('MEDICINA')) return 'MI';
    if (value === 'SO' || value === 'SAO' || value.includes('SALUD ORAL')) return 'SAO';
    if (value === 'CEM' || value.includes('EMERGENCIA')) return 'CEM';
    return '';
  }

  private getIdCotizacionEnCurso(): number | null {
    if (this._idCotizacionOverride && this._idCotizacionOverride > 0) {
      return this._idCotizacionOverride;
    }
    const { tipoDocumento, numeroDocumento } = this.getDocumentoActual();
    const fromActual = this.getIdCotizacionActual(
      tipoDocumento,
      numeroDocumento,
    );
    if (fromActual != null) return fromActual;

    const fromCreada = this.getIdCotizacionCreada(
      tipoDocumento,
      numeroDocumento,
    );
    if (fromCreada != null) return fromCreada;

    const fromPrecargada = this.getIdCotizacionPrecargada(
      tipoDocumento,
      numeroDocumento,
    );
    if (fromPrecargada != null) return fromPrecargada;

    const fromProgramas = this.getIdCotizacionFromProgramasContratante(
      tipoDocumento,
      numeroDocumento,
    );
    if (fromProgramas != null) return fromProgramas;

    // cotizacion_cargada es exclusiva de edición; en venta nueva no debe resolver el id.
    if (this.esContextoEdicion()) {
      const fromCargada = this.getIdCotizacionFromKey(
        this.KEY_COTIZACION_CARGADA,
        tipoDocumento,
        numeroDocumento,
      );
      if (fromCargada != null) return fromCargada;

      // Legacy plano sin documento: solo como último recurso en edición (colectivo usa otro componente).
      const legacy = Number(localStorage.getItem('idCotizacion'));
      if (Number.isFinite(legacy) && legacy > 0) {
        return legacy;
      }
    }

    return null;
  }

  /**
   * true solo en edición (Mis Cotizaciones o editMode en precargada).
   * cotizacion_cargada solo se escribe en ese contexto; fuera de él no debe usarse.
   */
  private esContextoEdicion(): boolean {
    try {
      if (localStorage.getItem('cotizacion_edicion_contratante')) {
        return true;
      }
      const rawPrec = localStorage.getItem(this.KEY_COTIZACION_PRECARGADA);
      if (rawPrec) {
        const prec = JSON.parse(rawPrec);
        if (prec?.editMode === true) {
          return true;
        }
      }
    } catch { /* no-op */ }
    return false;
  }

  /**
   * Retoma incompleta (precargada sin editMode). En edición la resuelve @Input idCotizacion / cargada / legacy.
   */
  private getIdCotizacionPrecargada(
    tipoDocumento: string,
    numeroDocumento: string,
  ): number | null {
    try {
      const raw = localStorage.getItem(this.KEY_COTIZACION_PRECARGADA);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (parsed?.editMode === true) {
        return null;
      }
    } catch { /* no-op */ }
    return this.getIdCotizacionFromKey(
      this.KEY_COTIZACION_PRECARGADA,
      tipoDocumento,
      numeroDocumento,
    );
  }

  private getDocumentoActual(): {
    tipoDocumento: string;
    numeroDocumento: string;
  } {
    let tipoDocumento = '';
    let numeroDocumento = '';
    try {
      const raw = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
      if (raw) {
        const parsed = JSON.parse(raw);
        tipoDocumento = (parsed?.tipoDocumento ?? '').toString().trim();
        numeroDocumento = (parsed?.numeroDocumento ?? '').toString().trim();
      }
    } catch {
      tipoDocumento = '';
      numeroDocumento = '';
    }

    const autoritativo = this.getDocumentoContratanteAutoritativo();
    if (autoritativo.tipoDocumento && autoritativo.numeroDocumento) {
      const hayDatosForm = !!tipoDocumento && !!numeroDocumento;
      const mismatch =
        hayDatosForm &&
        (tipoDocumento !== autoritativo.tipoDocumento ||
          numeroDocumento !== autoritativo.numeroDocumento);
      if (!hayDatosForm || mismatch) {
        return autoritativo;
      }
    }

    return { tipoDocumento, numeroDocumento };
  }

  /** Documento del contratante real según keys de cotización (no datosRQ002 contaminado por beneficiario). */
  private getDocumentoContratanteAutoritativo(): {
    tipoDocumento: string;
    numeroDocumento: string;
  } {
    try {
      const rawCreada = localStorage.getItem(this.KEY_COTIZACION_CREADA);
      if (rawCreada) {
        const creada = JSON.parse(rawCreada);
        const tipoDocumento = (creada?.tipoDocumento ?? '').toString().trim();
        const numeroDocumento = (creada?.numeroDocumento ?? '').toString().trim();
        const id = Number(creada?.idCotizacion ?? creada?.data?.idCotizacion);
        if (tipoDocumento && numeroDocumento && Number.isFinite(id) && id > 0) {
          return { tipoDocumento, numeroDocumento };
        }
      }
    } catch {
      // no-op
    }

    try {
      const raw = localStorage.getItem(this.KEY_PROGRAMAS_CONTRATANTE);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
          const tipoDocumento = (parsed?.tipoDocumento ?? '').toString().trim();
          const numeroDocumento = (parsed?.numeroDocumento ?? '').toString().trim();
          const id = Number(parsed?.idCotizacion);
          if (tipoDocumento && numeroDocumento && Number.isFinite(id) && id > 0) {
            return { tipoDocumento, numeroDocumento };
          }
        }
      }
    } catch {
      // no-op
    }

    return { tipoDocumento: '', numeroDocumento: '' };
  }

  private getIdCotizacionFromProgramasContratante(
    tipoDocumento: string,
    numeroDocumento: string,
  ): number | null {
    try {
      const raw = localStorage.getItem(this.KEY_PROGRAMAS_CONTRATANTE);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
        return null;
      }
      const tipo = (parsed?.tipoDocumento ?? '').toString().trim();
      const num = (parsed?.numeroDocumento ?? '').toString().trim();
      const docCoincide =
        !!tipo && !!num && tipo === tipoDocumento && num === numeroDocumento;
      if (!docCoincide) return null;
      const id = Number(parsed?.idCotizacion);
      return Number.isFinite(id) && id > 0 ? id : null;
    } catch {
      return null;
    }
  }

  private getIdCotizacionActual(
    tipoDocumento: string,
    numeroDocumento: string,
  ): number | null {
    try {
      const raw = localStorage.getItem(this.KEY_COTIZACION_ACTUAL);
      if (!raw) return null;
      const actual: CotizacionContratanteActual = JSON.parse(raw);
      const tipo = (actual?.tipoDocumento ?? '').toString().trim();
      const num = (actual?.numeroDocumento ?? '').toString().trim();
      const docCoincide =
        !!tipo && !!num && tipo === tipoDocumento && num === numeroDocumento;
      if (!docCoincide) return null;
      const id = Number(actual?.idCotizacion);
      return Number.isFinite(id) && id > 0 ? id : null;
    } catch {
      return null;
    }
  }

  private getIdCotizacionCreada(
    tipoDocumento: string,
    numeroDocumento: string,
  ): number | null {
    try {
      const raw = localStorage.getItem(this.KEY_COTIZACION_CREADA);
      if (!raw) return null;
      const created = JSON.parse(raw);
      const tipo = (created?.tipoDocumento ?? '').toString().trim();
      const num = (created?.numeroDocumento ?? '').toString().trim();
      const docCoincide =
        !!tipo && !!num && tipo === tipoDocumento && num === numeroDocumento;
      if (!docCoincide) return null;
      const id = Number(created?.idCotizacion ?? created?.data?.idCotizacion);
      return Number.isFinite(id) && id > 0 ? id : null;
    } catch {
      return null;
    }
  }

  /**
   * Lee idCotizacion de una key de localStorage.
   * Si se proveen tipoDocumento/numeroDocumento Y la key almacena documento,
   * exige que coincidan (evita tomar un id de otra cotización/contratante,
   * p. ej. cotizacion_precargada residual con id viejo). Si la key no guarda
   * documento (ej. cotizacion_cargada), no se puede validar y se usa el id tal cual.
   */
  private getIdCotizacionFromKey(
    key: string,
    tipoDocumento?: string,
    numeroDocumento?: string,
  ): number | null {
    try {
      const raw = localStorage.getItem(key);
      if (!raw) return null;
      const parsed = JSON.parse(raw);

      const tipoKey = (parsed?.tipoDocumento ?? '').toString().trim();
      const numKey = (parsed?.numeroDocumento ?? '').toString().trim();
      const debeValidarDoc =
        !!tipoDocumento && !!numeroDocumento && (!!tipoKey || !!numKey);
      if (debeValidarDoc) {
        const docCoincide = tipoKey === tipoDocumento && numKey === numeroDocumento;
        if (!docCoincide) return null;
      }

      const id = Number(parsed?.idCotizacion ?? parsed?.data?.idCotizacion);
      return Number.isFinite(id) && id > 0 ? id : null;
    } catch {
      return null;
    }
  }

  private estadoProgramaFueModificado(
    state: EstadoLiquidacionPrograma
  ): boolean {
    const inicial = this.estadoInicialPorPrograma.get(state.programaId);

    // En una cotización nueva todavía no existe información persistida.
    if (!inicial) {
      return this.idEstadoCotizacionActual === 2;
    }

    const normalizarFecha = (fecha: any): string =>
      fecha ? new Date(fecha).toISOString().substring(0, 10) : '';

    return (
      state.proporcionalidad !== inicial.proporcionalidad ||
      normalizarFecha(state.fechaIngreso) !==
        normalizarFecha(inicial.fechaIngreso) ||
      Number(state.diaCorte || 0) !== Number(inicial.diaCorte || 0) ||
      state.aplicaCuotaInscripcion !== inicial.aplicaCuotaInscripcion ||
      Number(state.valorCuotaInscripcion || 0) !==
        Number(inicial.valorCuotaInscripcion || 0) ||
      Number(state.mesesProntoPago || 0) !==
        Number(inicial.mesesProntoPago || 0) ||
      Boolean(state.aplicaTarifaAsociado) !==
        Boolean(inicial.aplicaTarifaAsociado)
    );
  }

  onEstadoLiquidacionProgramaChange(
    state: EstadoLiquidacionPrograma
  ): void {
    this.estadoPorPrograma.set(state.programaId, state);
    this.recalcularBotonesPorEstado();

    if (
      !this.cargaInicialTerminada ||
      this.inicializandoEstado ||
      this.bloqueoPostGuardadoExitoso
    ) {
      return;
    }

    this.cambiosSinGuardar = Array.from(
      this.estadoPorPrograma.values()
    ).some((estado) => this.estadoProgramaFueModificado(estado));

    if (this.cambiosSinGuardar) {
      this.guardadoExitoso = false;
    }
  }

  onCalculoPendienteProgramaChange(evento: CalculoPendientePrograma): void {
    if (evento.revision !== this._cargaRevision) {
      return;
    }

    const key = `programa:${evento.programaId}:${evento.operacion}`;
    if (evento.pendiente) {
      this.iniciarOperacionCarga(key, evento.revision);
    } else {
      this.finalizarOperacionCarga(key, evento.revision);
    }
  }

  private iniciarCargaInicial(): number {
    this._cargaRevision += 1;
    this.operacionesCargaPendientes.clear();
    this.cargaInicialTerminada = false;
    this.cargandoUltimaPantalla = true;
    this.cargaInicialChange.emit(true);
    return this._cargaRevision;
  }

  private iniciarOperacionCarga(operacion: string, revision: number): void {
    if (revision !== this._cargaRevision) {
      return;
    }
    this.operacionesCargaPendientes.add(operacion);
    if (!this.cargandoUltimaPantalla) {
      this.cargandoUltimaPantalla = true;
      this.cargaInicialChange.emit(true);
    }
  }

  private finalizarOperacionCarga(operacion: string, revision: number): void {
    if (revision !== this._cargaRevision) {
      return;
    }
    this.operacionesCargaPendientes.delete(operacion);
    this.actualizarEstadoCarga(revision);
  }

  private actualizarEstadoCarga(revision: number): void {
    if (revision !== this._cargaRevision) {
      return;
    }
    if (this.esperandoInicializacionProgramas) {
      return;
    }
    const pendiente = this.operacionesCargaPendientes.size > 0;
    this.cargandoUltimaPantalla = pendiente;
    if (!pendiente) {
      this.cargaInicialTerminada = true;
      this.cargaInicialChange.emit(false);
    }
  }

  salirCotizador(): void {
    if (!this.cambiosSinGuardar) {
      this.router.navigate(['/main/miscotizaciones']);
      return;
    }

    Swal.fire({
      title: 'Cambios sin guardar',
      text: '¿Deseas salir sin guardar la información actual? Los datos ingresados podrían perderse.',
      icon: 'warning',
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: 'Guardar y salir',
      denyButtonText: 'Salir sin guardar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.guardarLiquidacion(() =>
          this.router.navigate(['/main/miscotizaciones']),
        );
        return;
      }
      if (result.isDenied) {
        this.router.navigate(['/main/miscotizaciones']);
      }
    });
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent): void {
    if (!this.cambiosSinGuardar) return;
    event.preventDefault();
    event.returnValue = '';
  }

  private recalcularBotonesPorEstado(): void {
    const estados = Array.from(this.estadoPorPrograma.values());
    if (!estados.length) {
      this.camposCompletosMock = false;
      return;
    }
    const completos = estados.every((s) => this.esEstadoProgramaValido(s));
    this.camposCompletosMock = completos;
  }

  private esEstadoProgramaValido(state: EstadoLiquidacionPrograma): boolean {
    if (!state.rows.length) return false;
    if (state.proporcionalidad === 'SI') {
      if (!state.fechaIngreso) return false;
      if (state.diaCorte == null || state.diaCorte < 1 || state.diaCorte > 30)
        return false;
    }
    if (
      state.aplicaCuotaInscripcion === 'SI' &&
      !Number.isFinite(Number(state.valorCuotaInscripcion))
    ) {
      return false;
    }
    if (
      state.columnaValorTabla === 'periodoPronto' &&
      (state.mesesProntoPago < 3 || state.mesesProntoPago > 12)
    ) {
      return false;
    }
    return true;
  }

  private guardarLiquidacion(onSuccess?: () => void): void {
    if (this.cargandoUltimaPantalla) {
      this.guardandoEnCurso = false;
      return;
    }

    const idCotizacion = this.obtenerConsecutivoParaDraft();

    if (!idCotizacion) {
      this.guardandoEnCurso = false;
      return;
    }

    const esActualizar =
      this.idEstadoCotizacionActual === this.ESTADO_GUARDADA ||
      this.idEstadoCotizacionActual === this.ESTADO_ENVIADA;

    const eraEnviada =
      this.idEstadoCotizacionActual === this.ESTADO_ENVIADA;

    const comparativoModificado = this.comparativoFueModificado();
    const huboModificaciones =
      this.cambiosSinGuardar ||
      this.cotizacionModificadaExternamente ||
      comparativoModificado;
    
    console.log('[VERSIONAMIENTO] Estado antes de guardar', {
      idCotizacion,
      idEstadoCotizacionActual:
        this.idEstadoCotizacionActual,
      esActualizar,
      eraEnviada,
      cambiosSinGuardar:
        this.cambiosSinGuardar,
      cotizacionModificadaExternamente:
        this.cotizacionModificadaExternamente,
      comparativoModificado,
      huboModificaciones,
    });
    
    if (esActualizar && !huboModificaciones) {
      console.log(
        '[guardarLiquidacion] omitido: la cotización no tiene modificaciones',
        {
          idCotizacion,
          idEstado: this.idEstadoCotizacionActual,
          cambiosSinGuardar: this.cambiosSinGuardar,
          cotizacionModificadaExternamente:
            this.cotizacionModificadaExternamente,
        }
      );

      this.guardandoEnCurso = false;
      this.guardadoExitoso = true;

      this.bloqueoPostGuardadoExitoso = true;
      this.bloqueoNavegacionChange.emit(true);

      const dialogRef = this.dialog.open(
        PopUpMensajeComponent,
        {
          width: '500px',
          maxWidth: '90vw',
          disableClose: true,
          data: {
            titulo: 'Confirmación',
            texto:
              `Cotización actualizada correctamente. ID: ${idCotizacion}. ` +
              'No se detectaron modificaciones, por lo tanto se conserva la versión actual.',
            tipoIcono: 'success',
            textoBoton: 'ACEPTAR',
          } as PopUpMensajeData,
        }
      );

      dialogRef.afterClosed().subscribe(() => {
        if (onSuccess) {
          onSuccess();
        }
      });

      return;
    }

    const liquidaciones = this.construirLiquidacionesDesdeEstado(idCotizacion);
    const fechaCreacion = new Date().toISOString();
    const contratosInclusion = this.crearCotizacionContratanteService.mapContratosInclusionFromStorage();
    const payload = {
      idCotizacion,
      liquidaciones,
      contratosInclusion,
    };

    const request$ = esActualizar
      ? this.http.put<GuardarLiquidacionBackendResponse>(
          this.actualizarLiquidacionUrl,
          payload,
        )
      : this.http.post<GuardarLiquidacionBackendResponse>(
          this.guardarLiquidacionUrl,
          payload,
        );

    request$.subscribe({
      next: (response) => {
        if (!response?.status) {
          this.guardandoEnCurso = false;
          this.mostrarErrorGuardado(
            response?.errorMessage ||
              response?.message ||
              'No fue posible guardar la información.',
          );
          return;
        }

        this.guardarLiquidacionesLocal(idCotizacion, {
          idCotizacion,
          guardadoEn: fechaCreacion,
          liquidaciones,
        });

        this.guardadoExitoso = true;
        this.cambiosSinGuardar = false;

        if (!esActualizar) {
          this.idEstadoCotizacionActual =
            this.ESTADO_GUARDADA;
        }

        this.guardarComparativoPostLiquidacion(
          idCotizacion,
          esActualizar,
          (cantidadComparativos) => {
            this.guardandoEnCurso = false;
            this.bloqueoPostGuardadoExitoso = true;
            this.bloqueoNavegacionChange.emit(true);

            // Evaluar la versión únicamente después de guardar
            // liquidaciones y comparativos.
            const debeEvaluarVersion =
              !esActualizar || huboModificaciones

            if (debeEvaluarVersion) {
              this.networkingMisCot
                .evaluarVersiones(idCotizacion)
                .subscribe({
                  next: (r) => {
                    console.log(
                      '[evaluarVersiones] individual:',
                      {
                        idCotizacion,
                        huboModificaciones,
                        esActualizar,
                        eraEnviada,
                        respuesta: r.data,
                      }
                    );

                    if (r.data?.versionCreada) {
                                  if (eraEnviada) {
                        this.idEstadoCotizacionActual =
                          this.ESTADO_GUARDADA;
                      }

                      this.versionCreadaEvent.emit(
                        idCotizacion
                      );
                    }
                  },
                  error: (e) => {
                    console.error(
                      '[evaluarVersiones] individual error:',
                      e
                    );
                  },
                });
            } else {
              console.log(
                '[evaluarVersiones] omitido: cotización sin modificaciones',
                {
                  idCotizacion,
                  huboModificaciones,
                  esActualizar,
                  eraEnviada,
                }
              );
            }

            const cantidadGuardadas =
              response?.data?.idsLiquidaciones?.length ?? liquidaciones.length;
            const mensajeOperacion = esActualizar ? 'actualizada' : 'guardada';
            const textoComparativo =
              cantidadComparativos > 0
                ? ` Comparativos: ${cantidadComparativos}.`
                : '';
            this.dialog.open(PopUpMensajeComponent, {
              width: '500px',
              maxWidth: '90vw',
              disableClose: true,
              data: {
                titulo: 'Confirmación',
                texto: `Cotización ${mensajeOperacion} correctamente. ID: ${idCotizacion}. Liquidaciones: ${cantidadGuardadas}.${textoComparativo}`,
                tipoIcono: 'success',
                textoBoton: 'ACEPTAR',
              } as PopUpMensajeData,
            });

            if (onSuccess) {
              onSuccess();
            }
          },
        );
      },
      error: (error) => {
        this.guardandoEnCurso = false;
        this.mostrarErrorGuardado(
          error?.error?.errorMessage ||
            error?.error?.message ||
            'No fue posible guardar la información.',
        );
      },
    });
  }

  private guardarComparativoPostLiquidacion(
    idCotizacion: number,
    esActualizar: boolean,
    onDone: (cantidadComparativos: number) => void,
  ): void {
    const seleccionPorLinea = this.obtenerSeleccionCompararPorLinea();
    const { comparativos, haySeleccionIncompleta } =
      this.construirPayloadComparativos(seleccionPorLinea);

    // Defensa: la validación debe ocurrir en guardar() antes de persistir liquidación.
    // Si llega incompleto aquí, no se envía comparativo (0 o 2 válidos sí).
    if (haySeleccionIncompleta) {
      this.mostrarAdvertenciaComparacionMinima();
    }

    // En primera guardada no se persiste comparativo si no hay pares válidos.
    // En actualización se envía vacío para limpiar comparativos previos (replace).
    if (!esActualizar && comparativos.length === 0) {
      onDone(0);
      return;
    }

    const payload = {
      idCotizacion,
      comparativos,
    };

    const request$ = esActualizar
      ? this.http.put<GuardarComparativoBackendResponse>(
          this.actualizarComparativoUrl,
          payload,
        )
      : this.http.post<GuardarComparativoBackendResponse>(
          this.guardarComparativoUrl,
          payload,
        );

    request$.subscribe({
      next: (response) => {
        if (!response?.status) {
          this.mostrarErrorGuardado(
            response?.errorMessage ||
              response?.message ||
              'Se guardó la liquidación, pero falló el guardado del comparativo.',
          );
          onDone(0);
          return;
        }

        const cantidadComparativos =
          response?.data?.idsComparativos?.length ?? comparativos.length;
        onDone(cantidadComparativos);
      },
      error: (error) => {
        this.mostrarErrorGuardado(
          error?.error?.errorMessage ||
            error?.error?.message ||
            'Se guardó la liquidación, pero falló el guardado del comparativo.',
        );
        onDone(0);
      },
    });
  }

  private obtenerSeleccionCompararPorLinea(): Map<string, string[]> {
    const result = new Map<string, string[]>();
    try {
      const raw = localStorage.getItem(this.KEY_COMPARAR_STORAGE);
      if (!raw) {
        return result;
      }
      const parsed = JSON.parse(raw) as Record<string, unknown>;
      if (!parsed || typeof parsed !== 'object') {
        return result;
      }

      Object.entries(parsed).forEach(([linea, ids]) => {
        if (!Array.isArray(ids)) {
          return;
        }
        const lista = ids
          .map((id) => String(id ?? '').trim())
          .filter(Boolean)
          .slice(0, 2);
        if (!lista.length) {
          return;
        }
        result.set(linea, lista);
      });
    } catch {
      return new Map<string, string[]>();
    }
    return result;
  }

  private guardarEstadoInicialComparativo(payload: Record<string, string[]>): void {
    this.comparativoInicialPorLinea.clear();
    Object.entries(payload).forEach(([linea, ids]) => {
      if (Array.isArray(ids)) {
        this.comparativoInicialPorLinea.set(linea, [...ids]);
      }
    });
  }

  private comparativoFueModificado(): boolean {
    const seleccionActual = this.obtenerSeleccionCompararPorLinea();

    if (seleccionActual.size !== this.comparativoInicialPorLinea.size) {
      return true;
    }

    for (const [linea, idsActual] of seleccionActual.entries()) {
      const idsInicial = this.comparativoInicialPorLinea.get(linea);
      if (!idsInicial) return true;

      const sortedActual = [...idsActual].sort();
      const sortedInicial = [...idsInicial].sort();

      if (sortedActual.length !== sortedInicial.length) return true;
      for (let i = 0; i < sortedActual.length; i++) {
        if (sortedActual[i] !== sortedInicial[i]) return true;
      }
    }

    return false;
  }

  private obtenerPComparativoParaJasper(): string {
    const seleccionPorLinea = this.obtenerSeleccionCompararPorLinea();

    const tieneComparativoLocal = Array.from(seleccionPorLinea.values()).some(
      (programasSeleccionados) => programasSeleccionados.length >= 2,
    );

    return tieneComparativoLocal || this.tieneComparativoBackend ? '1' : '0';
  }

  private obtenerPCuotaInscripcionParaJasper(): string {
  const estados =
    Array.from(this.estadoPorPrograma.values());

  return estados.some(
    estado => estado.pCuotaInscripcion === '1'
  )
    ? '1'
    : '0';
  }

  private obtenerPPagoProporcionalParaJasper(): string {
    const estados =
      Array.from(this.estadoPorPrograma.values());

    return estados.some(
      estado =>
        estado.pPagoProporcionalAnticipado === '1'
    )
      ? '1'
      : '0';
  }

  private obtenerPPrecioBaseAnexosParaJasper(): string {
    const estados =
      Array.from(this.estadoPorPrograma.values());

    return estados.some(
      estado => estado.pPrecioBaseAnexos === '1'
    )
      ? '1'
      : '0';
  }

  private obtenerPTarifaAsociadoParaJasper(): string {
    const estados =
      Array.from(this.estadoPorPrograma.values());

    return estados.some(
      estado => estado.pTarifaAsociado === '1'
    )
      ? '1'
      : '0';
  }

  private hidratarCompararDesdeBackend(idCotizacion: number, revision: number): void {
    this.iniciarOperacionCarga('comparativo', revision);
    this.consultarCotizacionService
      .consultarCotizacionComparativo(idCotizacion)
      .pipe(finalize(() => this.finalizarOperacionCarga('comparativo', revision)))
      .subscribe({
        next: (response) => {
          if (!response?.status) {
            this.tieneComparativoBackend = false;
            return;
          }

          const comparativos = response?.data?.comparativos ?? [];

          this.tieneComparativoBackend = comparativos.length > 0;

          const payload =
            this.mapearCompararStorageDesdeComparativos(comparativos);

          this.guardarEstadoInicialComparativo(payload);
          ResumenCotizacionProgramaComponent.aplicarCompararDesdeBackend(payload);
        },
        error: () => {
          this.tieneComparativoBackend = false;
        },
      });
  }

  private mapearCompararStorageDesdeComparativos(
    comparativos: ComparativoSeleccionConsultaItem[],
  ): Record<string, string[]> {
    const byLinea = new Map<string, string[]>();
    const idPorLineaPrograma = new Map<string, string>();

    this.resumenProgramas.forEach((programa) => {
      const linea = (programa.lineaNegocio ?? '')
        .toString()
        .trim()
        .toUpperCase();
      const codigo = this.obtenerCodigoProgramaDesdeResumen(programa);
      if (!linea || !codigo) return;
      idPorLineaPrograma.set(`${linea}|${codigo}`, programa.programaId);
    });

    (comparativos ?? []).forEach((item) => {
      const linea = (item?.lineaNegocio ?? '').toString().trim().toUpperCase();
      const p1 = (item?.programa1 ?? '').toString().trim();
      const p2 = (item?.programa2 ?? '').toString().trim();
      if (!linea || !p1 || !p2) return;

      const id1 = idPorLineaPrograma.get(`${linea}|${p1}`);
      const id2 = idPorLineaPrograma.get(`${linea}|${p2}`);
      if (!id1 || !id2) return;

      const current = byLinea.get(linea) ?? [];
      const merged = [...current, id1, id2]
        .map((id) => id.trim())
        .filter(Boolean)
        .filter((id, idx, arr) => arr.indexOf(id) === idx)
        .slice(0, 2);
      if (!merged.length) return;
      byLinea.set(linea, merged);
    });

    const output: Record<string, string[]> = {};
    byLinea.forEach((ids, linea) => {
      output[linea] = ids;
    });
    return output;
  }

  private obtenerCodigoProgramaDesdeResumen(
    programa: ResumenProgramaItem,
  ): string {
    const fromRows = (programa?.rows?.[0]?.modalPrograma ?? '')
      .toString()
      .trim();
    if (fromRows) {
      return fromRows;
    }
    const programaId = (programa?.programaId ?? '').toString();
    const partes = programaId.split('|');
    const codigo = partes.length > 1 ? partes[1] : programaId;
    return (codigo || '').toString().trim();
  }

  private construirPayloadComparativos(
    seleccionPorLinea: Map<string, string[]>,
  ): {
    comparativos: ComparativoBackendItemRequest[];
    haySeleccionIncompleta: boolean;
  } {
    const comparativos: ComparativoBackendItemRequest[] = [];
    let haySeleccionIncompleta = false;

    // Helper para extraer el código real del programaId (ej. "1|5000100|0" -> "5000100")
    const extraerCodigo = (programaId: string) => {
      const partes = programaId.split('|');
      return partes.length > 1 ? partes[1] : programaId;
    };

    seleccionPorLinea.forEach((programasSeleccionados, lineaStorage) => {
      if (programasSeleccionados.length === 1) {
        haySeleccionIncompleta = true;
        return;
      }
      if (programasSeleccionados.length < 2) {
        return;
      }

      const [idPrograma1, idPrograma2] = programasSeleccionados;
      const state1 = this.estadoPorPrograma.get(idPrograma1);
      const state2 = this.estadoPorPrograma.get(idPrograma2);
      if (!state1 || !state2) {
        haySeleccionIncompleta = true;
        return;
      }

      const total1 = this.calcularTotalesPrograma(state1);
      const total2 = this.calcularTotalesPrograma(state2);
      const lineaNegocio = (state1.lineaNegocio || lineaStorage || '')
        .toString()
        .trim()
        .toUpperCase();

      comparativos.push({
        lineaNegocio: lineaNegocio || 'MI',
        // ¡Cambiamos aquí para mandar el código real a la BD!
        programa1: extraerCodigo(idPrograma1),
        programa2: extraerCodigo(idPrograma2),
        precioBaseMensualTotalP1: this.formatearNumeroComparativo(
          total1.precioBaseMensual,
        ),
        precioBaseMensualAnexosP1: this.formatearNumeroComparativo(
          total1.precioBaseMensualAnexos,
        ),
        descuentoCampaniaTotalP1: this.formatearNumeroComparativo(
          total1.descuentoCampania,
        ),
        pagoProporcionalTotalP1: this.formatearNumeroComparativo(
          total1.pagoProporcional,
        ),
        porcentajeDescuentoProntoP1: this.formatearNumeroComparativo(
          total1.porcentajeProntoPagoPromedio,
          1,
        ),
        valorTotalProntoP1: this.formatearNumeroComparativo(
          total1.valorTotalPronto,
        ),
        precioBaseMensualTotalP2: this.formatearNumeroComparativo(
          total2.precioBaseMensual,
        ),
        precioBaseMensualAnexosP2: this.formatearNumeroComparativo(
          total2.precioBaseMensualAnexos,
        ),
        descuentoCampaniaTotalP2: this.formatearNumeroComparativo(
          total2.descuentoCampania,
        ),
        pagoProporcionalTotalP2: this.formatearNumeroComparativo(
          total2.pagoProporcional,
        ),
        porcentajeDescuentoProntoP2: this.formatearNumeroComparativo(
          total2.porcentajeProntoPagoPromedio,
          1,
        ),
        valorTotalProntoP2: this.formatearNumeroComparativo(
          total2.valorTotalPronto,
        ),
      });
    });

    return {
      comparativos,
      haySeleccionIncompleta,
    };
  }

  private calcularTotalesPrograma(state: EstadoLiquidacionPrograma): {
    precioBaseMensual: number;
    precioBaseMensualAnexos: number;
    descuentoCampania: number;
    pagoProporcional: number;
    porcentajeProntoPagoPromedio: number;
    valorTotalPronto: number;
  } {
    const rows = state?.rows ?? [];
    const precioBaseMensual = rows.reduce(
      (acc, row) => acc + Number(row.precioBaseMensual || 0),
      0,
    );
    const precioBaseMensualAnexos = rows.reduce(
      (acc, row) => acc + Number(row.precioBaseMensualAnexos || 0),
      0,
    );
    const descuentoCampania = rows.reduce(
      (acc, row) => acc + Number(row.descuentosCampana || 0),
      0,
    );
    const pagoProporcional = rows.reduce(
      (acc, row) => acc + Number(row.pagoProporcionalIngresoAnticipado || 0),
      0,
    );
    const valorTotalPronto = rows.reduce(
      (acc, row) => acc + Number(row.valorTotalPeriodoProntoPago || 0),
      0,
    );
    const porcentajeProntoPagoPromedio = rows.length
      ? rows.reduce(
          (acc, row) => acc + Number(row.descuentoProntoPago || 0),
          0,
        ) / rows.length
      : 0;

    return {
      precioBaseMensual,
      precioBaseMensualAnexos,
      descuentoCampania,
      pagoProporcional,
      porcentajeProntoPagoPromedio,
      valorTotalPronto,
    };
  }

  private obtenerCodigoPrograma(state: EstadoLiquidacionPrograma): string {
    const porFila = (state?.rows?.[0]?.modalPrograma ?? '').toString().trim();
    if (porFila) {
      return porFila;
    }
    const programaId = (state?.programaId ?? '').toString();
    const partes = programaId.split('|');
    const codigo = partes.length > 1 ? partes[1] : programaId;
    return (codigo || '0').toString().trim() || '0';
  }

  private formatearNumeroComparativo(
    value: number,
    maxDecimales?: number,
  ): string {
    const numeric = Number(value ?? 0);
    if (!Number.isFinite(numeric)) {
      return '0';
    }
    const normalized =
      maxDecimales != null ? numeric.toFixed(maxDecimales) : String(numeric);
    const sinCerosFinales = normalized
      .replace(/\.0+$/, '')
      .replace(/(\.\d*?)0+$/, '$1');
    return sinCerosFinales || '0';
  }

  private mostrarAdvertenciaComparacionMinima(): void {
    this.dialog.open(PopUpMensajeComponent, {
      width: '500px',
      maxWidth: '90vw',
      disableClose: true,
      data: {
        titulo: 'Advertencia',
        texto:
          'La opción de comparación solo aplica para 2 programas de la misma línea de negocio.',
        tipoIcono: 'warning',
        textoBoton: 'ACEPTAR',
      } as PopUpMensajeData,
    });
  }

  /**
   * Prorratea un monto en N partes a 2 decimales.
   * El residuo de centavos queda en la última parte para que la suma == total.
   */
  private prorratearMontoEnCentavos(total: number, cantidad: number): number[] {
    if (!(cantidad > 0) || !Number.isFinite(total) || total <= 0) {
      return Array.from({ length: Math.max(cantidad, 0) }, () => 0);
    }
    const totalCents = Math.round(total * 100);
    const base = Math.floor(totalCents / cantidad);
    const resto = totalCents - base * cantidad;
    return Array.from({ length: cantidad }, (_, i) => {
      const cents = i === cantidad - 1 ? base + resto : base;
      return cents / 100;
    });
  }

  private construirLiquidacionesDesdeEstado(
    idCotizacion: number,
  ): LiquidacionDraftRowStorage[] {
    const liquidaciones: LiquidacionDraftRowStorage[] = [];
    const fechaCreacion = new Date().toISOString();
    this.estadoPorPrograma.forEach((state) => {
      const filasValidas = state.rows.filter((row) => {
        const idBeneficiario = Number(row.idBeneficiario ?? 0);
        const idBenPrograma = Number(row.idBenPrograma ?? 0);
        return idBeneficiario > 0 && idBenPrograma > 0;
      });

      const aplicaCuota = state.aplicaCuotaInscripcion === 'SI';
      const porBeneficiario = !!state.aplicacionCuotaPorBeneficiario;
      const totalContrato =
        aplicaCuota && !porBeneficiario
          ? Number(state.valorCuotaInscripcion || 0)
          : 0;
      // Modo programa/contrato: total en _CONTRATO + desglose prorrateado en
      // VALOR_CUOTA_INSCRIPCION (PDF pinta fila a fila sin sumar).
      const cuotasProrrateadas =
        aplicaCuota && !porBeneficiario
          ? this.prorratearMontoEnCentavos(totalContrato, filasValidas.length)
          : [];

      filasValidas.forEach((row, index) => {
        let valorCuotaInscripcion = 0;
        let valorCuotaInscripcionContrato = 0;
        if (aplicaCuota) {
          if (porBeneficiario) {
            valorCuotaInscripcion = Number(row.cuotaInscripcionValor || 0);
            valorCuotaInscripcionContrato = 0;
          } else {
            valorCuotaInscripcion = Number(cuotasProrrateadas[index] || 0);
            valorCuotaInscripcionContrato = totalContrato;
          }
        }

        liquidaciones.push({
          idCotizacion,
          idBeneficiario: Number(row.idBeneficiario ?? 0),
          idBenPrograma: Number(row.idBenPrograma ?? 0),
          precioBaseMensual: Number(row.precioBaseMensual || 0),
          precioBaseMensualAnexos: Number(row.precioBaseMensualAnexos || 0),
          descuentoCampania: Number(row.descuentosCampana || 0),
          idCotizacionCampania: row.idCotizacionCampania ?? null,
          aplicaProporcionalidad: state.proporcionalidad === 'SI' ? 'S' : 'N',
          fechaIngreso: state.fechaIngreso,
          diaCorte: state.diaCorte,
          diasProporcionalidad: Number(state.diasProporcionalidad || 0),
          valorProporcional: Number(row.pagoProporcionalIngresoAnticipado || 0),
          aplicaCuotaInscripcion: aplicaCuota ? 'S' : 'N',
          valorCuotaInscripcion,
          valorCuotaInscripcionContrato,
          // mesesProntoPago: Number(state.mesesProntoPago || 12),
          mesesProntoPago: Number(state.mesesProntoPago ?? 0),
          pctDescuentoProntoPago: Number(row.descuentoProntoPago || 0),
          valorTotalProntoPago: Number(row.valorTotalPeriodoProntoPago || 0),
          aplicaTarifaAsociado: state.aplicaTarifaAsociado ? 'S' : 'N',
          precioBaseTarifaAsociado: Number(row.precioBaseTarifaAsociado || 0),
          fechaCreacion,
        });
      });
    });
    return liquidaciones;
  }

  private getStorageKeyLiquidaciones(idCotizacion: number): string {
    return `${this.KEY_RQ005_LIQUIDACIONES_GUARDADAS}_${idCotizacion}`;
  }

  private guardarLiquidacionesLocal(
    idCotizacion: number,
    data: LiquidacionDraftStorage,
  ): void {
    localStorage.setItem(
      this.getStorageKeyLiquidaciones(idCotizacion),
      JSON.stringify(data),
    );
  }

  /**
   * Construye el mapa de estado inicial por programaId a partir de liquidacionesIndividual
   * retornado por el backend. Solo actúa en modo edición; en creación el array llega vacío/null.
   */
  private construirEstadoInicialDesdeBackend(liqArray: LiquidacionIndividualItem[] | undefined): void {
    this.estadoInicialPorPrograma.clear();
    if (!liqArray?.length) return;

    const liqPorIdBenPrograma =
      new Map<number, LiquidacionIndividualItem>(
        liqArray.map((liquidacion) => [
          Number(liquidacion.idBenPrograma),
          liquidacion,
        ])
      );

    // Restaurar en cada fila los valores persistidos de la liquidación.
    // Esto evita recalcularlos y sobrescribirlos al ingresar por Editar.
    this.resumenProgramas = this.resumenProgramas.map((item) => ({
      ...item,
      rows: item.rows.map((row) => {
        const idBenPrograma = Number(row.idBenPrograma ?? 0);
        const liquidacion = liqPorIdBenPrograma.get(idBenPrograma);

        if (!liquidacion) {
          return row;
        }

        return {
          ...row,

          precioBaseMensual:
            Number(
              liquidacion.precioBaseMensual ??
              row.precioBaseMensual ??
              0
            ),

          precioBaseMensualAnexos:
            Number(
              liquidacion.precioBaseMensualAnexos ??
              row.precioBaseMensualAnexos ??
              0
            ),
            
          descuentosCampana:
            Number(liquidacion.descuentoCampania ?? 0),

          pagoProporcionalIngresoAnticipado:
            Number(liquidacion.valorProporcional ?? 0),

          descuentoProntoPago:
            Number(liquidacion.pctDescuentoProntoPago ?? 0),

          valorTotalPeriodoProntoPago:
            Number(liquidacion.valorTotalProntoPago ?? 0),

          precioBaseTarifaAsociado:
            Number(liquidacion.precioBaseTarifaAsociado ?? 0),

          cuotaInscripcionValor:
            Number(liquidacion.valorCuotaInscripcion ?? 0),

          idCotizacionCampania:
            liquidacion.idCotizacionCampania ?? null,
        };
      }),
    }));

    for (const item of this.resumenProgramas) {
      if (this.estadoInicialPorPrograma.has(item.programaId)) continue;
      for (const row of item.rows) {
        const idBenProg = Number(row.idBenPrograma ?? 0);
        if (idBenProg <= 0) continue;
        const liq = liqPorIdBenPrograma.get(idBenProg);
        if (!liq) continue;
        // row.precioBaseMensual =
        //   Number(liq.precioBaseMensual ?? row.precioBaseMensual ?? 0);

        // row.precioBaseMensualAnexos =
        //   Number(liq.precioBaseMensualAnexos ?? row.precioBaseMensualAnexos ?? 0);

        // row.descuentosCampana =
        //   Number(liq.descuentoCampania ?? 0);

        // row.idCotizacionCampania =
        //   liq.idCotizacionCampania ?? null;

        // row.pagoProporcionalIngresoAnticipado =
        //   Number(liq.valorProporcional ?? 0);

        // row.descuentoProntoPago =
        //   Number(liq.pctDescuentoProntoPago ?? 0);

        // row.valorTotalPeriodoProntoPago =
        //   Number(liq.valorTotalProntoPago ?? 0);

        // row.precioBaseTarifaAsociado =
        //   Number(liq.precioBaseTarifaAsociado ?? 0);

        // row.cuotaInscripcionValor =
        //   Number(liq.valorCuotaInscripcion ?? 0);
        this.estadoInicialPorPrograma.set(item.programaId, {
          proporcionalidad: liq.aplicaProporcionalidad === 'S' ? 'SI' : 'NO',
          fechaIngreso: liq.fechaIngreso ?? null,
          diaCorte: liq.diaCorte ?? null,
          aplicaCuotaInscripcion: liq.aplicaCuotaInscripcion === 'S' ? 'SI' : 'NO',
          // Preferir contrato (línea+programa) si viene cargado; si no, valor por beneficiario.
          valorCuotaInscripcion: Number(liq.valorCuotaInscripcionContrato || 0) > 0
            ? Number(liq.valorCuotaInscripcionContrato)
            : Number(liq.valorCuotaInscripcion ?? 0),
          // mesesProntoPago: liq.mesesProntoPago ?? 12,
          mesesProntoPago: liq.mesesProntoPago ?? 0,
          aplicaTarifaAsociado: liq.aplicaTarifaAsociado === 'S',
        });
        break; // primer match encontrado para esta card
      }
    }
  }

  private hidratarGuardadoLocalPorCotizacion(idCotizacion: number): void {
    const raw = localStorage.getItem(
      this.getStorageKeyLiquidaciones(idCotizacion),
    );
    if (!raw) {
      this.guardadoExitoso = false;
      return;
    }
    try {
      const parsed = JSON.parse(raw) as LiquidacionDraftStorage;
      this.guardadoExitoso = Number(parsed?.idCotizacion ?? 0) === idCotizacion;
    } catch {
      this.guardadoExitoso = false;
    }
  }

  private mostrarErrorGuardado(mensaje: string): void {
    this.dialog.open(PopUpMensajeComponent, {
      width: '500px',
      maxWidth: '90vw',
      disableClose: true,
      data: {
        titulo: 'Error',
        texto: mensaje,
        tipoIcono: 'error',
        textoBoton: 'ACEPTAR',
      } as PopUpMensajeData,
    });
  }

  private obtenerConsecutivoParaDraft(): number | null {
    const existente = this.getIdCotizacionEnCurso();
    if (existente && existente > 0) {
      return existente;
    }
    const actual = Number(
      localStorage.getItem(this.KEY_RQ005_CONSECUTIVO_LOCAL) || '0',
    );
    const siguiente = Number.isFinite(actual) && actual > 0 ? actual + 1 : 1;
    localStorage.setItem(this.KEY_RQ005_CONSECUTIVO_LOCAL, String(siguiente));
    return siguiente;
  }
}
